module.exports = __webpack_public_path__ + "static/media/11.cc1ca70e.jpg";